export const lightScrollbarStyle = {
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#bdbdbd",
    border: "1px solid #9e9e9e",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#9e9e9e",
  },
  scrollbarWidth: "thin",
  scrollbarColor: "#bdbdbd transparent",
};
